// extracted by mini-css-extract-plugin
export default {"notice":"LegalNotice_notice__wgFgc","compact":"LegalNotice_compact__3g1M0"};